import { render, staticRenderFns } from "./StatusButtons.vue?vue&type=template&id=4ed5edf9"
import script from "./StatusButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusButtons.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports